import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from './RequireAuth'
import { RequireRole } from './RequireRole'
import { IndexRedirect } from './IndexRedirect'
import { EditorLayout } from '../components/EditorLayout'
import { VcardEditorPage } from '../pages/VcardEditorPage'
import { MyVcardPage } from '../pages/MyVcardPage'
import { EditorNotFound } from '../pages/EditorNotFound'
import { ShowcasePage } from '../pages/ShowcasePage'
import { EditorLoginPage } from '../pages/EditorLoginPage'

/** Router-Teilbaum unter /editor/* (Pfade relativ, da App.tsx /editor/* mountet). */
export function EditorRoutes() {
  return (
    <Routes>
      {/* Editor-Login (F2-Split): reiner OTP-Flow, anonym erreichbar (TP2 §D4). */}
      <Route path="login" element={<EditorLoginPage />} />

      {/* Interne UI-Abnahme (TP1 Kitchen-Sink). CO-1: nur im Dev-Build registriert
          (`import.meta.env.DEV`) — im Prod-Bundle ist /editor/_showcase damit nicht
          öffentlich erreichbar (fällt auf die Bereichs-404). */}
      {import.meta.env.DEV && <Route path="_showcase" element={<ShowcasePage />} />}
      <Route element={<RequireAuth />}>
        <Route element={<EditorLayout />}>
          <Route index element={<IndexRedirect />} />

          {/* Einzelne vCard bearbeiten (admin/brand-admin edit-on-behalf; user-
              Scope-Feinschliff erst TP5, hier wie bisher gegatet). */}
          <Route element={<RequireRole roles={['admin', 'brand-admin']} />}>
            <Route path="vcards/:urlKey" element={<VcardEditorPage />} />
          </Route>

          {/* nur user: eigene vCard */}
          <Route element={<RequireRole roles={['user']} />}>
            <Route path="me" element={<MyVcardPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<EditorNotFound />} />
    </Routes>
  )
}
